
(function(){
  function ready(fn){if(document.readyState!=='loading')fn();else document.addEventListener('DOMContentLoaded',fn)}

  function initSuccessSliders(root){
    (root||document).querySelectorAll('[data-rb-success-slider]').forEach(function(slider){
      if(slider.dataset.rbInit==='1') return; slider.dataset.rbInit='1';
      var wrap=slider.closest('[data-rb-success-wrap]')||slider.parentElement;
      var slides=slider.querySelectorAll('.slide');
      var dots=wrap?wrap.querySelectorAll('.dot'):[];
      var gap=parseFloat(slider.dataset.gap||'0');
      var autoplay=slider.dataset.autoplay==='true';
      var speed=parseInt(slider.dataset.speed||'2000',10);
      var index=0,timer;
      function width(){return slides[0]?slides[0].offsetWidth+gap:0}
      function go(i){if(!slides.length)return; index=(i+slides.length)%slides.length; slider.scrollTo({left:width()*index,behavior:'smooth'}); dots.forEach(function(d){d.classList.remove('active')}); if(dots[index])dots[index].classList.add('active')}
      dots.forEach(function(dot){dot.addEventListener('click',function(){go(parseInt(dot.dataset.index||'0',10))})});
      if(dots.length)dots[0].classList.add('active');
      if(autoplay){timer=setInterval(function(){go(index+1)},speed)}
      window.addEventListener('resize',function(){go(index)},{passive:true});
    });
  }

  function initExpectedResults(root){
    (root||document).querySelectorAll('[data-rb-ers]').forEach(function(S){
      if(S.dataset.rbInit==='1') return; S.dataset.rbInit='1';
      var range=S.querySelector('[data-ers-range]'); if(!range)return;
      var beforeWrap=S.querySelector('[data-ers-before-wrap]');
      var handle=S.querySelector('[data-ers-handle]');
      var dayEl=S.querySelector('[data-ers-day]');
      var descEl=S.querySelector('[data-ers-desc]');
      var barItems=S.querySelectorAll('[data-ers-bar-item]');
      var slider=S.querySelector('[data-ers-slider]');
      var beforeImg=S.querySelector('.ers-before');
      var steps=[];
      try{steps=JSON.parse((S.querySelector('[data-ers-steps]')||{}).textContent||'[]')}catch(e){steps=[]}
      function getStep(val){val=Number(val); if(val<34)return 0; if(val<67)return 1; return 2}
      var lastStep=-1;
      function setSliderWidth(){if(slider&&beforeImg)beforeImg.style.width=slider.offsetWidth+'px'}
      function update(){var val=Number(range.value); var step=getStep(val); if(beforeWrap)beforeWrap.style.width=val+'%'; if(handle)handle.style.left=val+'%'; if(step!==lastStep){lastStep=step; if(dayEl)dayEl.textContent=step+1; if(descEl&&steps[step])descEl.textContent=steps[step].desc; barItems.forEach(function(item,i){item.classList.toggle('active',i===step)})}}
      setSliderWidth(); update(); window.addEventListener('resize',function(){setSliderWidth();update()},{passive:true}); range.addEventListener('input',update,{passive:true});
    });
  }

  ready(function(){initSuccessSliders();initExpectedResults()});
  document.addEventListener('shopify:section:load',function(e){initSuccessSliders(e.target);initExpectedResults(e.target)});
})();

(function () {
  function initImageSliders(scope) {
    const rootScope = scope || document;

    rootScope.querySelectorAll("[data-rb-img-slider-section]").forEach((section) => {
      if (section.dataset.rbInitialized === "true") return;
      section.dataset.rbInitialized = "true";

      const slides = Array.from(section.querySelectorAll("[data-rb-img-slide]"));
      const dots = Array.from(section.querySelectorAll("[data-rb-img-dot]"));
      const prev = section.querySelector("[data-rb-img-prev]");
      const next = section.querySelector("[data-rb-img-next]");

      if (!slides.length) return;

      let index = 0;
      let timer = null;
      const autoplay = section.dataset.autoplay === "true";
      const speed = Number(section.dataset.speed || 2000);

      function showSlide(i) {
        index = (i + slides.length) % slides.length;

        slides.forEach((slide, idx) => {
          slide.classList.toggle("is-active", idx === index);
        });

        dots.forEach((dot, idx) => {
          dot.classList.toggle("is-active", idx === index);
        });
      }

      function nextSlide() {
        showSlide(index + 1);
      }

      function start() {
        if (!autoplay || slides.length <= 1) return;
        stop();
        timer = setInterval(nextSlide, speed);
      }

      function stop() {
        if (timer) {
          clearInterval(timer);
          timer = null;
        }
      }

      if (prev) {
        prev.addEventListener("click", function () {
          showSlide(index - 1);
          start();
        });
      }

      if (next) {
        next.addEventListener("click", function () {
          showSlide(index + 1);
          start();
        });
      }

      dots.forEach((dot) => {
        dot.addEventListener("click", function () {
          showSlide(Number(dot.dataset.rbImgDot || 0));
          start();
        });
      });

      section.addEventListener("mouseenter", stop);
      section.addEventListener("mouseleave", start);

      showSlide(0);
      start();
    });
  }

  document.addEventListener("DOMContentLoaded", function () {
    initImageSliders(document);
  });

  document.addEventListener("shopify:section:load", function (event) {
    initImageSliders(event.target);
  });
})();

(function () {
  function initSimpleSliders(scope) {
    const rootScope = scope || document;

    rootScope.querySelectorAll("[data-rb-simple-slider]").forEach((section) => {
      if (section.dataset.rbInitialized === "true") return;
      section.dataset.rbInitialized = "true";

      const track = section.querySelector("[data-rb-slider-track]");
      const slides = Array.from(section.querySelectorAll(".rb-simple-slider__slide"));
      const dots = Array.from(section.querySelectorAll("[data-rb-slider-dot]"));

      if (!track || !slides.length) return;

      let index = 0;
      let timer = null;
      const autoplay = section.dataset.autoplay === "true";
      const speed = Number(section.dataset.speed || 2000);

      function getGap() {
        const style = window.getComputedStyle(track);
        return parseFloat(style.columnGap || style.gap || 0) || 0;
      }

      function update(i) {
        index = (i + slides.length) % slides.length;
        const slideWidth = slides[0].offsetWidth + getGap();

        track.scrollTo({
          left: slideWidth * index,
          behavior: "smooth"
        });

        dots.forEach((dot, idx) => {
          dot.classList.toggle("is-active", idx === index);
        });
      }

      function start() {
        if (!autoplay || slides.length <= 1) return;
        stop();
        timer = setInterval(() => update(index + 1), speed);
      }

      function stop() {
        if (timer) clearInterval(timer);
        timer = null;
      }

      dots.forEach((dot) => {
        dot.addEventListener("click", () => {
          update(Number(dot.dataset.rbSliderDot || 0));
          start();
        });
      });

      section.addEventListener("mouseenter", stop);
      section.addEventListener("mouseleave", start);

      window.addEventListener("resize", () => update(index), { passive: true });

      update(0);
      start();
    });
  }

  document.addEventListener("DOMContentLoaded", () => initSimpleSliders(document));

  document.addEventListener("shopify:section:load", (event) => {
    initSimpleSliders(event.target);
  });
})();


/* Exclusive Offer section */
document.addEventListener("click", async function (event) {
  const btn = event.target.closest("[data-rb-copy-code]");
  if (!btn) return;

  const code = btn.dataset.rbCopyCode;
  const text = btn.querySelector("[data-rb-copy-text]");
  if (!code || !text) return;

  try {
    await navigator.clipboard.writeText(code);
    const old = text.textContent;
    text.textContent = "COPIED";
    setTimeout(() => {
      text.textContent = old;
    }, 1200);
  } catch (e) {}
});

/* Ingredients Showcase Slider*/

(function () {
  function initShowcaseSliders(scope) {
    const root = scope || document;

    root.querySelectorAll("[data-rb-showcase-slider]").forEach((section) => {
      if (section.dataset.rbShowcaseInitialized === "true") return;
      section.dataset.rbShowcaseInitialized = "true";

      const track = section.querySelector("[data-rb-showcase-track]");
      const cards = Array.from(section.querySelectorAll(".rb-ingredient-showcase__card"));
      const prev = section.querySelector("[data-rb-showcase-prev]");
      const next = section.querySelector("[data-rb-showcase-next]");

      if (!track || !cards.length) return;

      let index = 0;
      let timer = null;
      const autoplay = section.dataset.autoplay === "true";
      const speed = Number(section.dataset.speed || 2000);

      function getStep() {
        const style = window.getComputedStyle(track);
        const gap = parseFloat(style.columnGap || style.gap || 0) || 0;
        return cards[0].offsetWidth + gap;
      }

      function visibleCount() {
        return window.innerWidth < 750 ? 2 : Math.max(1, Math.floor(track.offsetWidth / getStep()));
      }

      function goTo(i) {
        const maxIndex = Math.max(0, cards.length - visibleCount());
        index = Math.max(0, Math.min(i, maxIndex));

        track.scrollTo({
          left: getStep() * index,
          behavior: "smooth"
        });

        if (index >= maxIndex && autoplay) {
          setTimeout(() => {
            index = -1;
          }, 250);
        }
      }

      function nextSlide() {
        goTo(index + 1);
      }

      function start() {
        if (!autoplay || cards.length <= 1) return;
        stop();
        timer = setInterval(nextSlide, speed);
      }

      function stop() {
        if (timer) clearInterval(timer);
        timer = null;
      }

      if (prev) {
        prev.addEventListener("click", function () {
          goTo(index - 1);
          start();
        });
      }

      if (next) {
        next.addEventListener("click", function () {
          goTo(index + 1);
          start();
        });
      }

      section.addEventListener("mouseenter", stop);
      section.addEventListener("mouseleave", start);

      window.addEventListener("resize", function () {
        goTo(index);
      }, { passive: true });

      goTo(0);
      start();
    });
  }

  document.addEventListener("DOMContentLoaded", function () {
    initShowcaseSliders(document);
  });

  document.addEventListener("shopify:section:load", function (event) {
    initShowcaseSliders(event.target);
  });
})();

/* Reasons Slider*/
(function () {
  function initProblemSliders(scope) {
    const root = scope || document;

    root.querySelectorAll("[data-rb-problem-slider]").forEach((section) => {
      if (section.dataset.rbProblemInitialized === "true") return;
      section.dataset.rbProblemInitialized = "true";

      const track = section.querySelector("[data-rb-problem-track]");
      const cards = Array.from(section.querySelectorAll(".rb-problem-card"));
      const dotsWrap = section.querySelector("[data-rb-problem-dots]");

      if (!track || !cards.length) return;

      let index = 0;
      let timer = null;
      const autoplay = section.dataset.autoplay === "true";
      const speed = Number(section.dataset.speed || 2000);

      if (dotsWrap) {
        dotsWrap.innerHTML = "";
        cards.forEach((_, i) => {
          const dot = document.createElement("button");
          dot.type = "button";
          dot.className = "rb-problem-dot";
          dot.setAttribute("aria-label", "Go to card " + (i + 1));
          dot.addEventListener("click", () => {
            goTo(i);
            start();
          });
          dotsWrap.appendChild(dot);
        });
      }

      const dots = dotsWrap ? Array.from(dotsWrap.querySelectorAll(".rb-problem-dot")) : [];

      function getGap() {
        const style = window.getComputedStyle(track);
        return parseFloat(style.columnGap || style.gap || 0) || 0;
      }

      function getStep() {
        return cards[0].offsetWidth + getGap();
      }

      function getVisibleCount() {
        return Math.max(1, Math.round(track.offsetWidth / getStep()));
      }

      function goTo(i) {
        const maxIndex = Math.max(0, cards.length - getVisibleCount());
        index = i > maxIndex ? 0 : i < 0 ? maxIndex : i;

        track.scrollTo({
          left: getStep() * index,
          behavior: "smooth"
        });

        dots.forEach((dot, idx) => {
          dot.classList.toggle("is-active", idx === index);
        });
      }

      function start() {
        if (!autoplay || cards.length <= 1) return;
        stop();
        timer = setInterval(() => goTo(index + 1), speed);
      }

      function stop() {
        if (timer) clearInterval(timer);
        timer = null;
      }

      section.addEventListener("mouseenter", stop);
      section.addEventListener("mouseleave", start);

      window.addEventListener("resize", () => goTo(index), { passive: true });

      goTo(0);
      start();
    });
  }

  document.addEventListener("DOMContentLoaded", () => initProblemSliders(document));

  document.addEventListener("shopify:section:load", (event) => {
    initProblemSliders(event.target);
  });
})();

document.addEventListener("click", function(e){
  const btn = e.target.closest("[data-rb-mobile-menu]");
  if(!btn) return;

  const menuBtn = document.querySelector(".header__icon--menu");

  if(menuBtn){
    menuBtn.click();
  }
});

(function(){
  const countEls = document.querySelectorAll("[data-rb-floating-cart-count]");

  if(!countEls.length) return;

  function updateFloatingCartCount(count){
    countEls.forEach(function(el){
      el.textContent = count > 0 ? count : "";
      el.setAttribute("data-count", count);
    });
  }

  function fetchCartCount(){
    fetch("/cart.js")
      .then(function(res){ return res.json(); })
      .then(function(cart){
        updateFloatingCartCount(cart.item_count || 0);
      })
      .catch(function(){});
  }

  document.addEventListener("DOMContentLoaded", fetchCartCount);

  document.addEventListener("cart:updated", fetchCartCount);
  document.addEventListener("cart:refresh", fetchCartCount);
  document.addEventListener("cart-drawer:updated", fetchCartCount);

  const originalFetch = window.fetch;

  window.fetch = function(){
    return originalFetch.apply(this, arguments).then(function(response){
      try{
        const url = typeof arguments[0] === "string" ? arguments[0] : arguments[0].url;

        if(
          url &&
          (
            url.includes("/cart/add") ||
            url.includes("/cart/change") ||
            url.includes("/cart/update") ||
            url.includes("/cart/clear")
          )
        ){
          setTimeout(fetchCartCount, 400);
        }
      }catch(e){}

      return response;
    });
  };
})();